// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReactAria from "react-aria";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

let Button = {};

let Hover = {};

let Link = {};

let Label = {};

let TextField = {};

let Checkbox = {};

let Select = {};

let Group = {};

let Radio = {
  Group: Group
};

let Selection = {};

let HeaderRow = {};

let ColumnHeader = {};

let RowGroup = {};

let Row = {};

let Cell = {};

let Layout = {};

let Table = {
  Selection: Selection,
  HeaderRow: HeaderRow,
  ColumnHeader: ColumnHeader,
  RowGroup: RowGroup,
  Row: Row,
  Cell: Cell,
  Layout: Layout
};

let Item = {};

let ToggleButtonGroup = {
  Item: Item
};

let Position = {};

let Trigger = {};

let Overlay = {
  Position: Position,
  Trigger: Trigger
};

let Popover = {};

let Dialog = {};

let Trigger$1 = {};

let Tooltip = {
  Trigger: Trigger$1
};

let DateSegment = {};

let TimeField = {};

let NumberField = {};

let Section = {};

let ListBox = {
  Section: Section
};

let List = {};

let Panel = {};

let Tab = {
  List: List,
  Panel: Panel
};

let Option = {};

let ProgressBar = {};

let ComboBox = {};

let Filter = {};

let Resize = {};

let DismissButton = {};

let VisuallyHidden = {};

let Within = {};

let Scope = {};

let Ring = {};

function useRing(prim0, prim1) {
  return ReactAria.useFocusRing(prim0 !== undefined ? Primitive_option.valFromOption(prim0) : undefined);
}

function useWithin(prim) {
  return ReactAria.useFocusWithin(prim);
}

let Focus = {
  Within: Within,
  Scope: Scope,
  Ring: Ring,
  useRing: useRing,
  useWithin: useWithin
};

let Clipboard = {};

let Press = {};

export {
  Button,
  Hover,
  Link,
  Label,
  TextField,
  Checkbox,
  Select,
  Radio,
  Table,
  ToggleButtonGroup,
  Overlay,
  Popover,
  Dialog,
  Tooltip,
  DateSegment,
  TimeField,
  NumberField,
  ListBox,
  Tab,
  Option,
  ProgressBar,
  ComboBox,
  Filter,
  Resize,
  DismissButton,
  VisuallyHidden,
  Focus,
  Clipboard,
  Press,
}
/* react-aria Not a pure module */
